import { PropsWithChildren, useCallback, useEffect } from 'react';

export type ScrollRowItem = {
  id: string;
};

type ScrollRowItemProps = ScrollRowItem & {
  register: (id: string, node: HTMLDivElement) => any;
  unregister: (id: string) => any;
};
export function ScrollRowItem({
  children,
  register,
  unregister,
  id,
}: PropsWithChildren<ScrollRowItemProps>) {
  const onRef = useCallback(
    (element: HTMLDivElement | null) => {
      if (element) {
        element.dataset.id = id;
        register(id, element);
      }
    },
    [id, register]
  );

  useEffect(() => {
    return () => {
      unregister(id);
    };
  }, [id, unregister]);

  return (
    <div className="snap-start snap-normal shrink-0" ref={onRef}>
      {children}
    </div>
  );
}
